export default "__VITE_ASSET__CHBowuUm__"